import Vue from "vue";
import Router from "vue-router";
import index from "./views/index.vue";
import {KEY_TOKEN} from "@/config";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "/Login",
      name: "Login",
      component: () => {
        switch (process.env.VUE_APP_CUSTOMER) {
          case 'jzz':
            return import("@/views/JzzLogin.vue")
          default:
            return import("@/views/Login.vue")
        }
      },
      meta: {
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "/Register",
      name: "Register",
      component: () => import("@/views/Register.vue"),
      meta: {
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "/Forget",
      name: "Forget",
      component: () => import("@/views/Forget.vue"),
      meta: {
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "/MyDevices",
      name: "MyDevices",
      component: () => import("@/views/MyDevices.vue"),
      meta: {
        keepAlive: false,
        auth: true
      }
    },
    {
      path: "/cartridges",
      name: "MyCartridges",
      component: () => import("@/views/MyCartridges.vue"),
      meta: {
        keepAlive: false,
        auth: true
      }
    },
    {
      path: "/Profile",
      name: "Profile",
      component: () => import("@/views/Profile.vue"),
      meta: {
        keepAlive: false,
        auth: true
      }
    },
    {
      path: "/Feedback",
      name: "Feedback",
      component: () => import("@/views/Feedback.vue"),
      meta: {
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "/findStore",
      name: "FindStore",
      component: () => import("@/views/FindStore.vue"),
      meta: {
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "/how-to-use",
      name: "HowtoUse",
      component: () => import("@/views/HowToUse.vue"),
      meta: {
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "*",
      redirect: {
        name: "/"
      }
    },],
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem(KEY_TOKEN);
  const deviceInfo = store.state.cartridge.deviceInfo
  const userInfo = store.state.user.userInfo
  if (token) {

    if (to.query && to.query.redirect && to.query.redirect !== '/') {
      next(`${to.query.redirect}`)
      return
    }

    next();
  } else {
    if (to.meta.auth) {
      next({
        name: deviceInfo.status === 0 ? "Login" : "Login",
        query: {
          redirect: to.fullPath,
        }
      });
      return;
    }
    next()
  }
})

export default router